import React from 'react';
import CategoryListingView from '../Categories/CategoryListingView';
import useDraftImageUrls from './useDraftImageUrls';
import { categoryImageUrl } from '../data/categoryImageUrl';

export default function CategoryPreviewPane({ category }) {
  const allImages = [category.coverImage, ...(category.dresses || []).flatMap((d) => d.images || [])].filter(Boolean);
  const previewImageUrl = useDraftImageUrls(allImages, categoryImageUrl);

  return (
    <div style={{ border: '1px solid rgba(201,162,75,.3)', position: 'sticky', top: 20 }}>
      <div style={{ padding: 12, borderBottom: '1px solid rgba(201,162,75,.3)', fontSize: 12, letterSpacing: '.12em', textTransform: 'uppercase', color: 'rgba(239,228,210,.55)' }}>
        Preview — Category page
      </div>
      <div style={{ maxHeight: 700, overflow: 'auto' }}>
        <CategoryListingView category={category} imageUrl={previewImageUrl} />
      </div>
    </div>
  );
}
